// NOTICE: KAPTION-INTEGRATION - whatsapp-flows: the business name the phone
// previews (wapreview) show in their header: the inbox's business name, else
// the inbox name, else the account name. Only falls back to "Business" when
// none is known yet.
import { computed, unref } from 'vue';
import { useStore } from 'dashboard/composables/store';

export const DEFAULT_BUSINESS_NAME = 'Business';

export const inboxBusinessName = (inbox, accountName = '') =>
  String(inbox?.business_name || '').trim() ||
  String(inbox?.name || '').trim() ||
  String(accountName || '').trim() ||
  DEFAULT_BUSINESS_NAME;

/**
 * @param {import('vue').MaybeRef<object|number|string|null>} inboxOrId
 *   an inbox object, or an inbox id looked up in the inboxes store.
 */
export function useKaptionBusinessName(inboxOrId) {
  const store = useStore();
  return computed(() => {
    const value = unref(inboxOrId);
    const inbox =
      value && typeof value === 'object'
        ? value
        : (value && store.getters['inboxes/getInbox']?.(Number(value))) || null;
    const accountId = store.getters.getCurrentAccountId;
    const account = accountId
      ? store.getters['accounts/getAccount']?.(accountId)
      : null;
    return inboxBusinessName(inbox, account?.name);
  });
}
